export default __webpack_public_path__ + "static/mobile-apps-teaser-section-256fe2516bec4bd5689be814c35e46d0.jpeg";